var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-staking"},[(!_vm.currentAccount)?[_c('f-message',{attrs:{"type":"error","with-icon":""}},[_vm._v("Bad wallet")])]:[_c('address-info-box'),_c('main',{staticClass:"main"},[_c('account-stake')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }